export default "__VITE_ASSET__CCNF4zP4__"